import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import Nav from "./Nav";
import NavSecondary from "./NavSecondary";
import "../../scss/layout/Header.scss";

function Header({ airplanes, setImagePath, setNavActive, ...props }) {
	const [currManufacture, setCurrManufacture] = useState(null);
	const location = useLocation();

	const handleClick = e => {
		let shortName = e.target.getAttribute("data-shortname");
		if (currManufacture === shortName) {
			shortName = null;
		}
		let picturePath = airplanes.Content[shortName]?.Picture;
		if (picturePath == null) {
			picturePath = "https://www.aviation24.be/wp-content/uploads/2015/03/747-8i.jpeg";
		}
		setImagePath(picturePath);
		setCurrManufacture(shortName);
	};

	useEffect(() => {
		if (window.innerWidth < 1080) setCurrManufacture(null);
		document.querySelector(".header input[type=checkbox]").checked = false;
		setNavActive(false);
	}, [location, setNavActive]);

	return (
		<div className="header_container">
			<header className="header">
				<div>
					<Link to="/" replace>
						<i className="fas fa-home home_icon"></i>
					</Link>
					<h1 className="logo" data-shortname="null" onClick={handleClick}>
						<Link to="/samoloty" replace>
							Samoloty
						</Link>
					</h1>
				</div>
				<input
					type="checkbox"
					className="fas fa-bars"
					onClick={e => setNavActive(e.target.checked)}
				/>
				<Nav manufactures={airplanes.TableOfContents.manufactures} handleClick={handleClick} />
			</header>
			<NavSecondary airplanes={airplanes.TableOfContents} manufacture={currManufacture} />
		</div>
	);
}

export default Header;
